import React, { ReactElement } from 'react';
import { Placeholder as PlaceholderType } from '@goodrx/x-core/dist/lib/types/Placeholder';
// @ts-ignore
import { Placeholder } from '@goodrx/x-matisse/dist/cjs/contentModels/Placeholder';
import { SignUpOnHomePage } from 'app/components/auth/SignUp/SignUpOnHomePage';
import { DrugSelector } from 'app/components/DrugSelector';

export interface PlaceholderOverrideProps extends PlaceholderType {
  className?: string;
}

export const PlaceholderOverride = (props: PlaceholderOverrideProps): ReactElement => {
  const { type } = props;

  if (type === 'hd_signup_form') {
    return <SignUpOnHomePage />;
  }

  if (type === 'sildenafil_drug_selector') {
    return <DrugSelector {...props} />;
  }

  return <Placeholder {...props} />;
};
